import script from "./Spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=2aca9dc2&lang=scss"

const __exports__ = script;

export default __exports__